"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var canMoveCurrentSnapshot_1 = require("./canMoveCurrentSnapshot");
/**
 * Clear all snapshots after the current one
 * @param snapshots The snapshots data structure to clear
 */
function clearProceedingSnapshots(snapshots) {
    if (canMoveCurrentSnapshot_1.default(snapshots, 1)) {
        var removedSize = 0;
        for (var i = snapshots.currentIndex + 1; i < snapshots.snapshots.length; i++) {
            removedSize += snapshots.snapshots[i].length;
        }
        snapshots.snapshots.splice(snapshots.currentIndex + 1);
        snapshots.totalSize -= removedSize;
    }
}
exports.default = clearProceedingSnapshots;
//# sourceMappingURL=clearProceedingSnapshots.js.map